import React, { useEffect, useRef, useState, useContext } from "react";
import { Box, Button, CircularProgress, Grid, Paper, Chip, TextField, MenuItem, Typography, Checkbox, Pagination, Select, FormControl, InputLabel } from "@mui/material";
import ApiService from "../../functions/apiService";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import moment from "moment-timezone";
import MyTable from "../../components/Schedule/MyTable";
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import FormControlLabel from '@mui/material/FormControlLabel';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import CollapseComponent from "./CollapseColumn";
import { Modal } from "react-bootstrap";

export default function ShiftCalls() {
	const { user } = useContext(AuthContext);
	const [searchParams, setSearchParams] = useSearchParams();
	const routeDate = searchParams.get('date') || moment().format('YYYY-MM-DD');
	const [loading, setLoading] = useState(false);
 const [selectedShiftType, setSelectedShiftType] = useState(null);
	const [allData, setAllData] = useState([]);
	const [listData, setListData] = useState([]);
	const [openListData, setOpenListData] = useState([]);
	const [assignedEmpListData, setAssignedEmpListData] = useState([]);
	const [type, setType] = useState('fillList')
	const [openShiftCount, setOpenShiftCount] = useState(0)
	const [blastFill, setBlastFill] = useState(false);
	const [blastMsg , setBlastMsg] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const rowsPerPage = 25;
	const [paginatedRows, setPaginatedRows] = useState([]);
	const totalPages = Math.ceil(listData.length / rowsPerPage);
	const [allowedVars , setAllowedVars] = useState({})
	const [timer , setTimer] = useState(30);
	const [startTime, setStartTime] = useState(null)
	const [endTime, setEndTime] = useState(null)
	const [openModal, setOpenModal] = useState(false)
	const [rowData, setRowData] = useState(null)
	const [positionArr, setPositionArr] = useState([])
	const [position, setPosition] = useState('')
	const [blastData, setBlastData] = useState(null)

	let getAllowedVars = () => {
		ApiService.get('/v3Variables')
			.then((res) => {
					setAllowedVars(res?.data?.data)
			}).catch(({ error }) => {
					console.log('error', error)
		});
	}
	
	useEffect(()=>{
		getAllowedVars();
	}, [])

	useEffect(() => {
		if (!Object.keys(allowedVars).length) return;

		if (allowedVars.V3_BLAST_FILL_DEFAULT_SHOW === 'true') {
			setBlastFill(true);
		}

		const showAll =
			allowedVars.V3_OPEN_POSITION_FILTER_BY_SELECTDATE === 'true' ||
			allowedVars.V3_24hour_to_Shift_calls === 'true';

		setSelectedShiftType(showAll ? 'ALL' : '1');
	}, [allowedVars]);
  

  useEffect(() => {
    setTimer(allowedVars.Blast_Fill_Time || 30)
  }, [allowedVars])

  let columnsList = [
    {
      field: 'fullName', headerName: 'Name', flex: 1, minWidth: 180,
      renderCell: (params) => {
        return params.row.employee.employee_assignment.EA_Rank + ' ' + params.row.employee.fullName;
      }
    },
    {
      field: 'Shift_Code', headerName: 'Shift', width: 130, minWidth: 130,
      renderCell: (params) => {
        const status = params.value;
        return <Chip
          sx={{
            height: 'auto',
            '& .MuiChip-label': {
              display: 'block',
              whiteSpace: 'normal',
            },
          }}
          style={{
            textAlign: 'center',
            padding: '6px 0px',
            width: '60%',
            color: '#2E3238',
            backgroundColor: status === 2 ? 'rgba(255, 165, 0, 0.26)' : 'rgba(52, 152, 219, 0.16)',
            border: status === 2 ? '1px solid rgba(255, 165, 0, 0.28)' : '1px solid rgba(52, 152, 219, 0.2)'
          }}
          label={status === 2 ? 'Day' : status === 3 ? 'Night' : 'Custom'}
        />;
      },
    },
    {
      field: 'Call_Times',
      headerName: 'Call Times',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return <p style={{ borderRadius: '20px', padding: '2px 8px', backgroundColor: '#555555', color: '#ffffff', marginTop: '18px' }}>
          {params.value}
        </p>
      },
    },
    {
      field: 'Status', headerName: 'Response', flex: 1, maxWidth: 120, minWidth: 120,
      renderCell: (params) => {
        return params.row.Status.toUpperCase();
      }
    },
    {
      field: 'Create_Time', headerName: 'First Called at', flex: 1, width: 130, minWidth: 180,
      renderCell: (params) => {
        let timeZone = 'America/New_York';
        let givenTimeUTC = moment.utc(params?.row?.Create_Time, 'YYYY-MM-DD HH:mm:ss');
        let timeInNY = givenTimeUTC.tz(timeZone).format('MM/DD/YYYY HH:mm:ss');
        // return varFormatTime(timeInNY, user?.Time_Format);
        return varFormatTime(params?.row?.Create_Time, user?.Time_Format);
      }
    },
    {
      field: 'Call_Date_Times', headerName: 'Recalled at', flex: 1, width: 130, minWidth: 180,
      renderCell: (params) => {
        const callDateTimes = params?.row?.Call_Date_Times;
        const callTimes = params?.row?.Call_Times;
        if (callDateTimes && callTimes != 1) {
          let timeZone = 'America/New_York';
          let lastDateTime = callDateTimes.split(',').pop().trim();
          let givenTimeUTC = moment.utc(lastDateTime, 'YYYY-MM-DD HH:mm:ss');
          let timeInNY = givenTimeUTC.tz(timeZone).format('MM/DD/YYYY HH:mm:ss');
          // return varFormatTime(timeInNY, user?.Time_Format);
          return varFormatTime(lastDateTime, user?.Time_Format);
        }
        else return ''
      }
    },
    {
      field: 'Action', headerName: 'Action', width: 160, minWidth: 160,
      renderCell: (params) => {
        return (
          <>
            {params.row.Status == 'accepted' && params?.row?.is_shift_logged == false &&
              <ButtonTheme
                color='primary'
                className='mx-2'
                onClick={() => {
                  setOpenModal(true)
                  getPositionDropdownData(params?.row)
                  setRowData(params?.row || [])
                }}
              >
                Assign Shift
              </ButtonTheme>
            }
            {params.row.Status == 'accepted' && params?.row?.is_shift_logged == true &&
              <Chip label="Accepted" sx={{
                backgroundColor: 'rgba(26, 241, 10, 0.3)',
                color: '#000000',
                padding: '4px 10px'
              }} />
            }
          </>
        )
      },
    },
  ];

  let columns = [
    {
      field: 'fullName', headerName: 'Name', flex: 1, maxWidth: 300,
      renderCell: (params) => {
        return params.row.employee.employee_assignment.EA_Rank + ' ' + params.row.employee.fullName;
      }
    },
    {
      field: 'Group_Code', headerName: 'Group', width: 280,
      // renderCell: (params) => {
      // 	return params?.row?.employee?.employee_assignment?.Group_Code style={{ color: "#BF1D2D", fontSize: "16px", fontWeight: "600", backgroundColor: "#BF1D2D1A", borderRadius: "50%", width: "26px" }}
      // },
      renderCell: (params) => {
        const groupCode = params?.row?.employee?.employee_assignment?.Group_Code;
        if (groupCode == "N/A" || groupCode == "") {
          return ''
        }
        return (
          <div style={{
            color: "#BF1D2D",
            fontSize: "16px",
            fontWeight: "600",
            backgroundColor: "#BF1D2D1A",
            borderRadius: 50,
            padding: '2px 10px',
            // width: "26px",
            // height: "26px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
            {groupCode}
          </div>
        );
      }
    },
    {
      field: 'Value', headerName: 'Availability', flex: 1, width: 130,
      renderCell: (params) => {
        return (
          <div style={{ whiteSpace: 'pre-wrap' }}>
            {
              params?.row?.Value === 'FULLTIME' ? (
                'FULLTIME'
              ) : (
                params?.row?.Value
                  ?.split(',')
                  .map(time => time.trim())
                  .filter(time => time)
                  .join('\n')
              )
            }
          </div>
        )
      },
    },
    ...(allowedVars?.V3_SHOW_OT_SIGNUP_TIMESTAMP ? [{
      field: "signupTime",
      headerName: "Signup Date & Time",
      flex: 1,
      valueGetter: (params) => params.row.Create_Time,
      renderCell: (params) => (
        <span>
          {params.row.Create_Time
            ? moment(params.row.Create_Time).format("MM/DD/YYYY HH:mm:ss")
            : "-"}
        </span>
      )
    }] : [])
  ];

  let openColumns = [
    {
      field: 'fullName',
      headerName: 'Name',
      flex: 1,
      maxWidth: 300,
      renderCell: (params) => {
        const displayName = params?.row?.orig_emp == null
          ? "DETAIL"
          : `${params?.row?.orig_emp?.employee_assignment?.EA_Rank} ${params?.row?.orig_emp?.First_name} ${params?.row?.orig_emp?.Last_name}`;

        return (
          <div style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.2',
          }}>
            {displayName}
          </div>
        );
      }
    },
    {
      field: 'Shift', headerName: 'Shift', flex: 1, maxWidth: 300,
      renderCell: (params) => {
        return params?.row?.shift == null ? "(" + varFormatTime(params?.row?.Start_Time, user?.Time_Format) + " - " + varFormatTime(params?.row?.End_Time, user?.Time_Format) + ")" : params?.row?.shift?.Shift;
      }
    }
  ];

  let assignedEmpColumns = [
    {
      field: 'fullName',
      headerName: 'Name',
      flex: 1,
      maxWidth: 300,
      renderCell: (params) => {
        const emp = params?.row?.employee;
        const rank = emp?.employee_assignment?.EA_Rank || '';
        const fullName = emp?.fullName || `${emp?.First_name || ''} ${emp?.Last_name || ''}`.trim();
        return (
          <div style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.2',
          }}>
            {`${rank} ${fullName}`.trim()}
          </div>
        );
      }
    },
    {
      field: 'Shift_Code', headerName: 'Shift', flex: 1, maxWidth: 300,
      renderCell: (params) => {
        return params?.row?.Shift_Code == 2 ? 'Day' : params?.row?.Shift_Code == 3 ? 'Night' : 'Custom';
      }
    },
  ];



  useEffect(() => {
    if (selectedShiftType && routeDate) {
      ShiftCallsList()
      BlastFill()
      OtShiftCallsList()
      AssignedShiftCallsList()
    }
  }, [selectedShiftType, routeDate])

  useEffect(() => {
    OpenShiftCallsList()
  }, [])

  useEffect(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    setPaginatedRows(listData.slice(startIndex, endIndex));
  }, [listData, currentPage]);

  let getPositionDropdownData = (data) => {
    if (data) {
      ApiService.get(`/getHitlistEmployeesPositions/${data?.Emp_Code}?date=${moment(data?.Shift_Date).format('YYYY-MM-DD')}&shiftCode=${data?.Shift_Code}`)
        .then((data) => {
          setPositionArr(data.data.data || [])
        })
        .catch((error) => {
          console.error(error || 'err')
        })
    }
  }

  let onSubmitAssign = (refresh = false) => {
    const req = {
      "Shift_Number": position.Shift_Number,
      "Shift_Date": moment(rowData?.Shift_Date).format('YYYY-MM-DD'),
      "Emp_Code": rowData?.Emp_Code,
      ...(refresh && { "clear_hitlist": true }),
    }
    ApiService.post('/hitlistAssignEmp', req)
      .then((res) => {
        toast.success(res?.message)
        setOpenModal(false)
        ShiftCallsList()
        OpenShiftCallsList()
      }).catch((err) => {
        toast.error(err?.data?.message)
      })
  }
const BlastFill = () => {
		ApiService.post("/blastFillStatus", {
			"Shift_Code": selectedShiftType === 'ALL' ? '1' : selectedShiftType,
			"Shift_Date": moment(routeDate).format('YYYY-MM-DD')
		})
			.then((data) => {
				setBlastData(data?.data)
			})
			.catch((error) => {
				console.error('BlastFill error', error)
			});
	};

	const ShiftCallsList = () => {
		setLoading(true)
		ApiService.post("/shiftCallsList", {
			"Shift_Code": selectedShiftType === 'ALL' ? '1' : selectedShiftType,
			"Shift_Date": moment(routeDate).format('YYYY-MM-DD')
		})
			.then((data) => {
				setListData(data?.data)
				setLoading(false)
			})
			.catch((error) => {
				setLoading(false)
			});
	};

	const OtShiftCallsList = () => {
		setLoading(true)
		ApiService.post("/otSignupListForShiftCalls", {
			"Shift_Code": selectedShiftType === 'ALL' ? '1' : selectedShiftType,
			"Shift_Date": moment(routeDate).format('YYYY-MM-DD')
		})
			.then((data) => {
				setAllData(data?.data?.overtimeSignups)
				setOpenShiftCount(data?.data?.openShifts)
				setLoading(false)
			})
			.catch((error) => {
				setLoading(false)
			});
	};

	useEffect(() => {
		if (selectedShiftType && routeDate) {
			ShiftCallsList()
			OtShiftCallsList()
			OpenShiftCallsList()
			AssignedShiftCallsList()
		}
	}, [selectedShiftType, routeDate])

	const sendShiftCalls = () => {
		setLoading(true)
		ApiService.post("/sendShiftCalls", {
			"Shift_Code": selectedShiftType === 'ALL' ? '1': selectedShiftType,
			"Shift_Date": moment(routeDate).format('YYYY-MM-DD')
		})
			.then((data) => {
				toast.success(data?.message)
				ShiftCallsList()
				setLoading(false)
				setType('fillList')
			})
			.catch((error) => {
				toast.error(error?.data?.message)
				setLoading(false)
			});
	};

	const BlastFillStart = () => {
		setLoading(true)
		ApiService.post("/blastFillStart", {
			"Shift_Date": moment(routeDate).format('YYYY-MM-DD'),
			"Shift_Code" : selectedShiftType === 'ALL' ? '1' : selectedShiftType ,
			"Message" : blastMsg , 
			"Blast_Time" : timer
		})
			.then((data) => {
				toast.success(data?.message)
				setTimer(allowedVars.Blast_Fill_Time || 30)
				setBlastMsg('')
				ShiftCallsList()
				setLoading(false)
			})
			.catch((error) => {
				toast.error(error?.data?.message)
				setLoading(false)
			});
	};

	const OpenShiftCallsList = (date) => {
			setLoading(true)
			ApiService.post("/openShiftsForShiftCalls", {
				"Shift_Code": selectedShiftType === 'ALL' || selectedShiftType === '1' ? null : selectedShiftType,
				"Shift_Date": date ? date : moment(routeDate).format('YYYY-MM-DD')
			})
				.then((data) => {
					setOpenListData(data?.data)
					setOpenShiftCount(data?.data?.length || 0)
					setLoading(false)
				})
				.catch((error) => {
					setLoading(false)
				});
		};

	const AssignedShiftCallsList = (date) => {
			if (allowedVars?.V3_HIDE_ASSIGNED_FROM_SHIFT_CALLS_LIST !== 'true') return;
			ApiService.post("/assignedShiftCallsList", {
				"Shift_Code": selectedShiftType === 'ALL' ? 1 : parseInt(selectedShiftType),
				"Shift_Date": date ? date : moment(routeDate).format('YYYY-MM-DD')
			})
				.then((data) => {
          const newData = data?.data
            ?.filter((assignData) => assignData?.Status !== 'pending')
            ?.map((assignData , index) => ({
              ...assignData,
              id: index + 1
            }))
					setAssignedEmpListData(newData || [])
				})
				.catch((error) => {
					console.error(error)
				});
		};

	useEffect(() => {
		const startIndex = (currentPage - 1) * rowsPerPage;
		const endIndex = startIndex + rowsPerPage;
		setPaginatedRows(listData.slice(startIndex, endIndex));
	}, [listData, currentPage]);
	const getShiftLabel = () => {
        switch (selectedShiftType) {
            case '2': return 'Day';
            case '3': return 'Night';
            case '1': return '24';
            case '91': return 'Custom';
            case 'ALL': return 'All/24';
            default: return '';
        }
    };


  return (
    <>
      {/* <ManagementHeaderNav /> */}
      <Box style={{ marginTop: "1rem" }}>
        <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
          <Grid item xs={12}>
            <Paper className="p-3">
              <Box className='d-flex justify-content-between'>
                <Box className='d-flex align-items-center' style={{ gap: '20px' }}>
                  <Typography variant="h5">Shift Calls</Typography>
                  {allowedVars?.V3_SHOW_OT_SIGNUP_TIMESTAMP && blastData?.Update_Time && (
                    <Chip
                      label={`Blast Fill send Time: ${moment(blastData.Update_Time).format('hh:mm:ss A')}`}
                      size="small"
                      sx={{
                        backgroundColor: 'rgba(33, 150, 243, 0.15)',
                        color: '#0d47a1',
                        border: '1px solid rgba(33, 150, 243, 0.3)',
                        fontWeight: 500,
                        fontSize: '13px',
                      }}
                    />
                  )}
                </Box>

                <div>
                  {allowedVars.Blast_Fill == 'true' &&
                    <FormControlLabel control={<Checkbox />} label="Blast Fill" className="mx-4"
                      checked={blastFill}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setBlastFill(isChecked);
                      }}
                    />
                  }

                  <Chip
                    style={{
                      backgroundColor: 'rgba(26, 241, 10, 0.3)',
                      color: '#000000',
                      width: '200px',
                      padding: '4px',
                      fontSize: '16px',
                      fontWeight: '400'
                    }}
                    className="mx-2"
                    label={`Open Positions: ${openShiftCount}`}
                  />
                  {type == 'otList' ?
                    <ButtonTheme
                      color='primary'
                      className='mx-2'
                      onClick={() => {
                        ShiftCallsList()
                        BlastFill()
                        setType('fillList')
                      }}
                    >
                      View Shift Calls List
                    </ButtonTheme>
                    :
                    <ButtonTheme
                      color='primary'
                      className='mx-2'
                      onClick={() => {
                        OtShiftCallsList()
                        setType('otList')
                      }}
                    >
                      View Signup List
                    </ButtonTheme>
                  }
                </div>
              </Box>
              <Grid container spacing={2} className="px-3 py-2 d-flex align-items-center">
                <Grid xs={3} md={2.5} className="mt-4">
                  <label style={{ fontSize: '14px' }}>Date</label>
                  <Box className='mt-1'>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        value={routeDate ? moment(routeDate).toDate() : new Date()}
                        onChange={(e) => {
                          OpenShiftCallsList(moment(e).format('YYYY-MM-DD'))
                          AssignedShiftCallsList(moment(e).format('YYYY-MM-DD'))
                          setSearchParams({ date: moment(e).format('YYYY-MM-DD') })
                          setType('fillList')
                        }}
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-root": {
                            height: '48px',
                            fontSize: '14px'
                          },
                        }}
                        disablePast
                        dateInputIcon={<CalendarTodayIcon />}
                      />
                    </LocalizationProvider>
                  </Box>
                </Grid>

                <Grid xs={3} md={2.5} className="mt-4 px-2">
                  <label style={{ fontSize: '14px' }}>Shift Type</label>
                  <Box className='mt-1'>
                    <TextField
                      className='w-100' color='secondary' variant="outlined"
                      select
                      placeholder="shift Type"
                      value={selectedShiftType}
                      onChange={(e) => {
                        setSelectedShiftType(e.target.value)
                        setType('fillList')
                      }}
                      InputProps={{
                        sx: {
                          height: '48px',
                          fontSize: '14px'
                        }
                      }}
                    >
                     {(allowedVars.V3_OPEN_POSITION_FILTER_BY_SELECTDATE === 'true' || allowedVars.V3_24hour_to_Shift_calls === 'true') &&
											<MenuItem value='ALL'>All/24</MenuItem>}
                      <MenuItem value='2'>Day</MenuItem>
                      <MenuItem value='3'>Night</MenuItem>
                      <MenuItem value='91'>Custom/Detail</MenuItem>
                    </TextField>
                  </Box>
                </Grid>

                {blastFill &&
                  <Grid xs={3} md={2.5} className="mt-4">
                    <label style={{ fontSize: '14px' }}>Time Interval (In Minutes ) </label>
                    <Box className='mt-1'>
                      <TextField
                        className='w-100' color='secondary' variant="outlined"
                        placeholder="timer"
                        value={timer}
                        type='number'
                        inputProps={{ min: 1 }}
                        onChange={(e) => {
                          setTimer(e.target.value);
                        }}
                        InputProps={{
                          sx: {
                            height: '48px',
                            fontSize: '14px'
                          }
                        }}
                      >
                      </TextField>
                    </Box>
                  </Grid>
                }

                {blastFill &&
                  <Grid xs={3} md={2.5} className="mt-4 px-2">
                    <label style={{ fontSize: '14px' }}>Blast Message</label>
                    <Box className='mt-1'>
                      <TextField
                        className='w-100' color='secondary' variant="outlined"
                        placeholder="Message"
                        value={blastMsg}
                        onChange={(e) => setBlastMsg(e.target.value)}
                        InputProps={{
                          sx: {
                            height: '48px',
                            fontSize: '14px'
                          }
                        }}
                      >
                      </TextField>
                    </Box>
                  </Grid>
                }

                <Grid item xs={12} sm={12} md={2} className="d-flex" style={{ marginTop: '35px', gap: 20 }}>
                  {!blastFill &&
                    <ButtonTheme
                      color='primary'
                      disabled={!searchParams || !selectedShiftType}
                      onClick={() => {
                        sendShiftCalls()
                        setType('fillList')
                      }}
                    >
                      {listData.some(i => i.Call_Times > 0) ? 'Refill' : 'Fill'}
                    </ButtonTheme>
                  }
                  {blastFill &&
                    <ButtonTheme
                      color='primary'
                      disabled={!searchParams || !selectedShiftType || !timer || !blastMsg}
                      onClick={() => {
                        BlastFillStart()
                        setType('fillList')
                      }}
                    >
                      Blast Fill
                    </ButtonTheme>
                  }
                </Grid>

              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12}>
            {loading && (
              <Paper className="p-3" style={{ minHeight: '460px' }}>
                <div style={{ display: "flex", gap: "20px" }}>

                  <div
                    style={{
                      width: '70%',
                      height: 425,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>

                  <div style={{ width: '30%' }}>
                    <CollapseComponent
                      name={"Open Positions"}
                      rows={openListData}
                      open={true}
                      columns={openColumns}
                      hideFooter={true}
                      checkboxSelection={false}
                    />
                    {allowedVars?.V3_HIDE_ASSIGNED_FROM_SHIFT_CALLS_LIST === 'true' &&
                      <CollapseComponent
                        name={"Assigned Emp Shift calls"}
                        rows={assignedEmpListData}
                        open={true}
                        columns={assignedEmpColumns}
                        hideFooter={true}
                        checkboxSelection={false}
                        useCustomId={true}
                      />
                    }
                  </div>

                </div>
              </Paper>
            )}


            {!loading &&
              <>
                {type == 'fillList' ?
                  <>
                    {listData.length > 0 &&
                      <Paper className="p-3" style={{ minHeight: '460px' }}>
                        <div style={{ display: 'flex', gap: '10px' }}>

                          <div style={{ width: '70%', display: 'flex', flexDirection: 'column', borderRight: '1px solid', paddingRight: '10px' }}>

                            <MyTable
                              rows={paginatedRows}
                              columns={columnsList}
                              hideFooter={true}
                              checkboxSelection={false}
                              useCustomId={true}
                            />

                            {totalPages > 1 &&
                              <Pagination
                                count={totalPages}
                                color="primary"
                                className="mt-2 d-flex"
                                style={{ justifyContent: 'center' }}
                                page={currentPage}
                                onChange={(event, page) => setCurrentPage(page)}
                              />}
                          </div>

                          <div style={{ width: '30%' }}>
                            <CollapseComponent
                              name={"Open Positions"}
                              rows={openListData}
                              open={true}
                              columns={openColumns}
                              hideFooter={true}
                              checkboxSelection={false}
                            />
                            {allowedVars?.V3_HIDE_ASSIGNED_FROM_SHIFT_CALLS_LIST === 'true' &&
                              <CollapseComponent
                                name={"Assigned Emp Shift calls"}
                                rows={assignedEmpListData}
                                open={true}
                                columns={assignedEmpColumns}
                                hideFooter={true}
                                checkboxSelection={false}
                                useCustomId={true}
                              />
                            }
                          </div>

                        </div>
                      </Paper>
                    }

                  </>
                  :
                  <>
                    {allData.length > 0 &&
                      <Paper className="p-3" style={{ minHeight: '460px' }}>
                        <MyTable
                          rows={allData}
                          columns={columns}
                          hideFooter={true}
                          checkboxSelection={false}
                        />
                      </Paper>
                    }
                  </>
                }
              </>
            }

            {type === 'otList' && allData?.length === 0 && (
              <Paper className="p-3" style={{ minHeight: '460px' }}>
                <div style={{ display: 'flex', gap: '10px' }}>

                  <div style={{
                    width: '70%',
                    height: 425,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                    <img src="/images/blur-logo.png" style={{ height: 200, width: 250 }} />
                    <span className="mt-4" style={{ color: "#555555" }}>
                      No list found
                    </span>
                  </div>

                  <div style={{ width: '30%' }}>
                    <CollapseComponent
                      name={"Open Positions"}
                      rows={openListData}
                      open={true}
                      columns={openColumns}
                      hideFooter={true}
                      checkboxSelection={false}
                    />
                    {allowedVars?.V3_HIDE_ASSIGNED_FROM_SHIFT_CALLS_LIST === 'true' &&
                      <CollapseComponent
                        name={"Assigned Emp Shift calls"}
                        rows={assignedEmpListData}
                        open={true}
                        columns={assignedEmpColumns}
                        hideFooter={true}
                        checkboxSelection={false}
                        useCustomId={true}
                      />
                    }
                  </div>

                </div>
              </Paper>
            )}



            {!loading && type === 'fillList' && listData?.length === 0 && (
              <Paper className="p-3" style={{ minHeight: '460px' }}>
                <div style={{ display: 'flex', gap: '10px' }}>

                  <div style={{
                    width: '70%',
                    height: 425,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}>
                    <img src="/images/blur-logo.png" style={{ height: 200, width: 250 }} />
                    <span className="mt-4" style={{ color: "#555555" }}>
                      No Calls Found
                    </span>
                  </div>

							<div style={{ width: '30%' }}>
								<CollapseComponent
								name={`Open Positions for ${moment(routeDate).format('MM/DD/YYYY')} ${getShiftLabel()}`}
								rows={openListData}
								open={true}
								columns={openColumns}
								hideFooter={true}
								checkboxSelection={false}
								/>
								{allowedVars?.V3_HIDE_ASSIGNED_FROM_SHIFT_CALLS_LIST === 'true' &&
									<CollapseComponent
									name={"Assigned Emp Shift calls"}
									rows={assignedEmpListData}
									open={true}
									columns={assignedEmpColumns}
									hideFooter={true}
									checkboxSelection={false}
									useCustomId={true}
									/>
								}
							</div>

                </div>
              </Paper>
            )}

          </Grid>
        </Grid>
      </Box>

      <Modal size="md" show={openModal} onHide={() => setOpenModal(false)}>
        <Modal.Body className='p-4'>
          <Box id="modal-modal-description" sx={{ mt: 1 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "baseline" }}>
              <p style={{ fontSize: '21px', fontWeight: '700' }}>
                {`${rowData?.employee?.employee_assignment?.EA_Rank} ${rowData?.employee?.fullName}`}
              </p>
              <img src="/images/close-icon.svg" style={{ cursor: 'pointer' }} onClick={() => setOpenModal(false)} />
            </div>
            <Box sx={{ minWidth: 120 }}>
              {positionArr?.length === 0 ? (
                <FormControl fullWidth>
                  <Select
                    displayEmpty
                    value={positionArr}
                    renderValue={(positionArr) => {
                      if (!positionArr || positionArr.length === 0) {
                        return <em>No open position for this user</em>;
                      }
                      return positionArr.join(", ");
                    }}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                  </Select>
                </FormControl>
              ) : (
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Position</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={position}
                    label="Position"
                    onChange={(e) => setPosition(e.target.value)}
                    MenuProps={{
                      PaperProps: { style: { maxWidth: 480 } },
                    }}
                  >
                    {positionArr.map((pos, index) => {
                      const label = `${pos?.employee_assignment?.position?.SO_Desc || `Detail${pos?.Detail_Text ? ` [${pos.Detail_Text.split(' ').slice(0, 5).join(' ')}${pos.Detail_Text.split(' ').length > 5 ? '...' : ''}]` : ''}`}, Shift ${pos?.Shift_Code == 2 ? '(Day)' : pos?.Shift_Code == 3 ? '(Night)' : `(Custom ${varFormatTime(`${pos?.Start_Time}-${pos?.End_Time}`, user?.Time_Format)})`}${pos?.employee_assignment?.position?.SO_Desc == null ? `, Assignment (${pos?.assignment?.SO_Desc})` : ''}`;
                      return (
                        <MenuItem
                          key={index}
                          value={pos}
                          title={label}
                          sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                        >
                          {label}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              )}
            </Box>
            <Box className='mt-3' sx={{ display: 'flex', gap: 2 }}>
              <ButtonTheme disabled={!position} color='primary' className='px-5' onClick={() => onSubmitAssign(false)}>
                Assign
              </ButtonTheme>
              {allowedVars?.V3_ALLOW_HITLIST_REFRESH_ACTION === 'true' && (
                <ButtonTheme disabled={!position} color='primary' className='px-5' onClick={() => onSubmitAssign(true)}>
                  Assign and Refresh hit list
                </ButtonTheme>
              )}
            </Box>
          </Box>
        </Modal.Body>
      </Modal>
    </>)
}
